export default function PHP_ob_get_contents() {
  return (
    <div>
      <h1>PHP_ob_get_contents</h1>
    </div>
  );
}
